import { Placeholder } from 'rsuite';

const SpotifyReportsLoader = () => (
	<>
		{
			new Array(50).fill(0).map((_, idx) => (
				<div
					key={idx}
					className="flex h-[82px] items-center font-bold border-b border-b-gray-200 text-black"
				>
					<div className="px-[8px] flex-1 gap-[16px] flex items-center">
						<Placeholder.Graph
							className="!h-[64px] !w-[64px] !min-w-[64px] !rounded-full"
							active
						/>

						<Placeholder.Graph
							className="!h-[24px]"
							active
						/>
					</div>
					<div className="px-[8px] w-[80px] flex items-center justify-end">
						<Placeholder.Graph
							className="!h-[16px] !w-[24px]"
							active
						/>
					</div>
					<div className="px-[8px] w-[220px] flex items-center">
						<Placeholder.Graph
							className="!h-[24px]"
							active
						/>
					</div>
					<div className="px-[8px] w-[180px] flex items-center">
						<Placeholder.Graph
							className="!h-[24px]"
							active
						/>
					</div>
					<div className="px-[8px] w-[160px] flex items-center">
						<Placeholder.Graph
							className="!h-[24px]"
							active
						/>
					</div>
					<div className="px-[8px] w-[260px] flex items-center justify-center gap-[24px]">
						<Placeholder.Graph
							className="!h-[16px] !w-[16px]"
							active
						/>

						<Placeholder.Graph
							className="!h-[16px] !w-[16px]"
							active
						/>

						<Placeholder.Graph
							className="!h-[16px] !w-[16px]"
							active
						/>

						<Placeholder.Graph
							className="!h-[16px] !w-[16px]"
							active
						/>

						<Placeholder.Graph
							className="!h-[16px] !w-[16px]"
							active
						/>
					</div>
				</div>
			))
		}
	</>
);

export default SpotifyReportsLoader;
